<span [matTooltip]="enabled ? 'Génération pdf' : 'Mémorisez le BC avec ses sites et son fournisseur.'">
    <button color="primary" [disabled]="!enabled" mat-raised-button
        type="button"
        (click)="print()">
        <mat-icon>print</mat-icon> Imprimer
    </button>
</span>
